import { isPlayerAccessDenied } from './playerAccessError';

/**
 * Default retry rule of every query: one retry, none on a closed access (it
 * will not open by retrying). Shared so a query adding its own case keeps it.
 */
export function defaultQueryRetry(failureCount: number, error: unknown): boolean {
  return !isPlayerAccessDenied(error) && failureCount < 1;
}
